
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/canada/[provinceUrlLabel]/[locationSlug]",
      function () {
        return require("private-next-pages/locations/canada/[provinceUrlLabel]/[locationSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations/canada/[provinceUrlLabel]/[locationSlug]"])
      });
    }
  